import React from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import Input from './Input';
import DropDown from './DropDown';
import validate from './Validations/shippingAddressFormValidation';
import styles from './ShippingAddressForm.css';
import { removeNonNumbers, formatPhoneNumber } from '../../util';

const CityField = () => (
  <div className={styles.city}>
    <Field label="City" type="text" name="city" component={Input} />
  </div>
);

const StateField = ({ states }) => (
  <div className={styles.state}>
    <Field
      label="State"
      type="select"
      name="state"
      component={DropDown}
      options={states}
    />
  </div>
);
StateField.propTypes = { states: PropTypes.array };

const ZipField = () => (
  <div className={styles.zip}>
    <Field label="Zip" type="text" name="postalCode" component={Input} />
  </div>
);

const PhoneField = () => (
  <div className={styles.phone}>
    <Field
      label="Phone"
      type="tel"
      name="phoneNumber"
      component={Input}
      maxLength={12}
      normalize={removeNonNumbers}
      format={formatPhoneNumber}
    />
  </div>
);

const ShippingAddressForm = ({ states, handleSubmit, invalid }) => (
  <form onSubmit={handleSubmit} className={styles.form}>
    <p className={styles.title}> Shipping Address</p>
    <Field
      label="Full Name"
      type="text"
      name="fullName"
      component={Input}
      readOnly
    />
    <Field
      label="Street Address"
      type="text"
      name="street1"
      component={Input}
    />
    <Field label="Additional" type="text" name="street2" component={Input} />
    <div className={styles.row}>
      <CityField />
      <StateField states={states} />
    </div>
    <div className={styles.row}>
      <ZipField />
      <PhoneField />
    </div>
    <button
      type="button"
      className={styles.button}
      disabled={invalid}
      onClick={handleSubmit}
    >
      Save
    </button>
  </form>
);

ShippingAddressForm.propTypes = {
  invalid: PropTypes.bool.isRequired,
  states: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'ShippingAddressForm',
  validate,
})(ShippingAddressForm);



// WEBPACK FOOTER //
// ./src/components/Forms/ShippingAddressForm.jsx